<div class="mydayglance ">

    <div class="dailyhighlights" *ngIf="hashighlights && this.DailyHighlights.length>0">
        <div class="tenpxtop"></div>

        <div class="glancetitle center">Daily Highlights</div>

        <div class="highlight" *ngFor="let highlightitem of DailyHighlights; let i=index;">

            <div *ngIf="!highlightitem.deduper && highlightitem.endafterbeforecurrent!='less'"
                [ngClass]="{'borderaround': highlightitem.highlightexpander === true,'noborderaround':highlightitem.highlightexpander === false || highlightitem.highlightexpander == undefined}">

                <div class="lineitem">
                    <a *ngIf="!highlightitem.highlightexpander" (click)="highlightitem.highlightexpander = !highlightitem.highlightexpander">
                        <i class="fa-solid fa-circle-plus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timecollapse" *ngIf="highlightitem.type!='Survey' && highlightitem.type!='All Day Activity' && highlightitem.type!='HT' && highlightitem.type!='OT'">{{highlightitem.begDate | date:'shortTime'}}</span>  

                            <span class="timecollapse" *ngIf="highlightitem.type=='All Day Activity'">All Day</span>

                            <span class="activityname">{{highlightitem.name}}
                                <span class="themeicon" *ngIf="highlightitem.themeIcon!=null"><i class="fa-solid " [ngClass]="highlightitem.themeIcon"></i></span>
                            </span>
                        </span>
                    </a>
                    <a *ngIf="highlightitem.highlightexpander" (click)="highlightitem.highlightexpander = !highlightitem.highlightexpander">
                        <i class="fa-solid fa-circle-minus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timeexpand" *ngIf="highlightitem.type!='Survey' && highlightitem.type!='All Day Activity' && highlightitem.type!='HT' && highlightitem.type!='OT' && highlightitem.type!='Evening Lounge Service'">{{highlightitem.begDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="highlightitem.type=='Evening Lounge Service'">{{highlightitem.begDate | date:'shortTime'}}</span>
                            
                            <span class="timecollapse" *ngIf="highlightitem.type!='Survey' && highlightitem.type!='All Day Activity' && highlightitem.type!='HT' && highlightitem.type!='OT' && highlightitem.type!='Evening Lounge Service'">&nbsp;-&nbsp;{{highlightitem.endDate | date:'shortTime'}}</span>
                            
                            <span class="timecollapse" *ngIf="highlightitem.type=='All Day Activity'">All Day</span>

                            <span class="activityname activitynameexpand">{{highlightitem.name}}
                                <span class="themeicon" *ngIf="highlightitem.themeIcon!=null"><i class="fa-solid " [ngClass]="highlightitem.themeIcon"></i></span>
                            </span>
                        </span>
                    </a>
                </div>

                <div class="row innerexpand" *ngIf="highlightitem.highlightexpander==true">
                    <div class="guestinfo" *ngIf="highlightitem.guestName!='' && highlightitem.guestName!=undefined && highlightitem.type=='EX'">
                        <span class="guestname">{{highlightitem.guestName}}</span>
                    </div>
                    
                    <div class="col-12" *ngIf="highlightitem.type!='OT'">
                        <div class="activitydesc">{{highlightitem.description}}</div>
                    </div>

                    <div class="activitylocationinfo" *ngIf="highlightitem.location!='' && highlightitem.location!=undefined && highlightitem.deck!='Side'">
                        <span class="activitylocation" *ngIf="highlightitem.type!='Cruise' && highlightitem.type!='Survey' && highlightitem.type!='HT' && highlightitem.type!='OT'">
                            <a [routerLink]="['/shiplocation', highlightitem.deck]">{{highlightitem.location}}</a>
                        </span>

                        <span *ngIf="highlightitem.type=='HT'" class="activitylocation">
                            <a href='http://maps.google.com/?q={{highlightitem.description}}' target="_blank">{{highlightitem.location}}</a>
                        </span>

                        <span class="activityDeck" *ngIf="highlightitem.deck!='' && highlightitem.deck!=undefined">&nbsp;|&nbsp;{{highlightitem.deck}}</span>
                    </div>

                    <div class="activitylocationinfo" *ngIf="highlightitem.location!='' && highlightitem.location!=undefined && highlightitem.deck=='Side'">
                        <span class="activitylocation" *ngIf="highlightitem.type!='Cruise' && highlightitem.type!='Survey' && highlightitem.type!='HT' && highlightitem.type!='OT'">{{highlightitem.location}}</span>

                        <span class="activitylocation" *ngIf="highlightitem.type=='Survey' && pagemask==false">
                            <a href="https://questionpro.com/t/ATOnPZ4Wrm?BookingCode={{rebcode}}&CruiseCode={{evtcode}}">Click here to complete the survey</a>
                        </span>
                    </div>

                </div>

            </div>
        </div>
    </div>

    <div class="tenpxtop"></div>
    <app-longgoldbar *ngIf="hashighlights && this.DailyHighlights.length>0"></app-longgoldbar>

    <div class="dailyactivities" *ngIf="this.SailingThroughDay.length>0">

        <div class="glancetitle center"><span class="quoted">Sailing&nbsp;</span><span> Through the Day</span></div>

        <div *ngIf="pagemask==false" class="toggleright"><mat-slide-toggle name="showpastact" [(ngModel)]="filterpastout">Show Past</mat-slide-toggle></div>

        <div class="borderpadding" *ngFor="let activityitem of SailingThroughDay; let i=index;">
    
            <div class="allactivities"
                *ngIf="((!activityitem.deduper && activityitem.type=='All Day Activity') || (!activityitem.deduper && activityitem.endafterbeforecurrent!='less' && !filterpastout)|| (!activityitem.deduper &&  filterpastout))"
                [ngClass]="{'borderaround': activityitem.expander === true, 'noborderaround': activityitem.expander !== true}">

                <div class="lineitem">
                    <a *ngIf="!activityitem.expander" (click)="activityitem.expander = !activityitem.expander">
                        <i class="fa-solid fa-circle-plus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timecollapse" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">{{activityitem.begDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='Cruise' || activityitem.type=='Evening Lounge Service'">{{activityitem.sortDate | date:'shortTime'}}</span>                     
                            
                            <span class="timecollapse" *ngIf="activityitem.type=='All Day Activity'">All Day</span>

                            <span *ngIf="activityitem.type!='Cruise'" class="activityname">{{activityitem.name}}
                                <span class="themeicon" *ngIf="activityitem.themeIcon!=null"><i class="fa-solid " [ngClass]="activityitem.themeIcon"></i></span>
                            </span>

                            <span *ngIf="activityitem.type=='Cruise'" class="activityname">{{activityitem.direction}}&nbsp;{{activityitem.name}}</span>
                        </span>
                    </a>
                    <a *ngIf="activityitem.expander" (click)="activityitem.expander = !activityitem.expander">
                        <i class="fa-solid fa-circle-minus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timeexpand" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">{{activityitem.begDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='Cruise' || activityitem.type=='Evening Lounge Service'">{{activityitem.sortDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='All Day Activity'">All Day</span>

                            <span class="timecollapse" *ngIf="activityitem.endDate!=undefined && activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">&nbsp;-&nbsp;{{activityitem.endDate | date:'shortTime'}}</span>

                            <span *ngIf="activityitem.type!='Cruise'" class="activityname activitynameexpand">{{activityitem.name}}
                                <span class="themeicon" *ngIf="activityitem.themeIcon!=null"><i class="fa-solid " [ngClass]="activityitem.themeIcon"></i></span>
                            </span>

                            <span *ngIf="activityitem.type=='Cruise'" class="activityname activitynameexpand">{{activityitem.direction}}&nbsp;{{activityitem.name}}</span>
                        </span>
                    </a>
                </div>

                <div class="row innerexpand" *ngIf="activityitem.expander == true">
                    <div class="col-12">
                        <div class="dailyhighlight" *ngIf="activityitem.isHighlighted"><i class="fa-solid fa-star fa-sm"></i><span>&nbsp;Daily Highlight</span></div>
                    </div>

                    <div class="guestinfo" *ngIf="activityitem.guestName!='' && activityitem.guestName!=undefined && activityitem.type=='EX'">
                        <span class="guestname">{{activityitem.guestName}}</span>
                    </div>

                    <div class="col-12" *ngIf="activityitem.type!='OT'">
                        <div class="activitydesc">{{activityitem.description}}</div>
                    </div>

                    <div class="activitylocationinfo" *ngIf="activityitem.location!='' && activityitem.location!=undefined && activityitem.deck!='Side'">           
                        <span class="activitylocation" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='HT' && activityitem.type!='OT'">
                            <a [routerLink]="['/shiplocation', activityitem.deck]">{{activityitem.location}}</a>
                        </span>

                        <span *ngIf="activityitem.type=='HT'" class="activitylocation">
                            <a href='http://maps.google.com/?q={{activityitem.description}}' target="_blank">{{activityitem.location}}</a>
                        </span>

                        <span class="activityDeck" *ngIf="activityitem.deck!='' && activityitem.deck!=undefined">&nbsp;|&nbsp;{{activityitem.deck}}</span>
                    </div>

                    <div class="activitylocationinfo" *ngIf="activityitem.location!='' && activityitem.location!=undefined  && activityitem.deck=='Side'">
                        <span class="activitylocation" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='HT' && activityitem.type!='OT'">{{activityitem.location}}</span>

                        <span class="activitylocation" *ngIf="activityitem.type=='Survey' && pagemask==false">
                            <a href="https://questionpro.com/t/ATOnPZ4Wrm?BookingCode={{rebcode}}&CruiseCode={{evtcode}}">Click here to complete the survey</a>
                        </span>
                    </div>

                </div>
            </div>
        </div>
    </div>

    <div class="tenpxtop" *ngIf="showtomorrow && this.LookingTowardTomorrow.length>0 && pagemask==false"></div>
    <app-longgoldbar *ngIf="showtomorrow && this.LookingTowardTomorrow.length>0 && pagemask==false"></app-longgoldbar>



    <div class="dailyactivities" *ngIf="showtomorrow && this.LookingTowardTomorrow.length>0 && pagemask==false">
        <div class="glancetitle center"><span class="quoted">Looking Toward Tomorrow&nbsp;</span></div>

        <div class="allactivities" *ngFor="let activityitem of LookingTowardTomorrow; let i=index;">

            <div *ngIf="!activityitem.deduper"
                [ngClass]="{'borderaround': activityitem.expander === true, 'noborderaround': activityitem.expander !== true}">

                <div class="lineitem">
                    <a *ngIf="!activityitem.expander" (click)="activityitem.expander = !activityitem.expander">
                        <i class="fa-solid fa-circle-plus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timecollapse" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">{{activityitem.begDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='Cruise' || activityitem.type=='Evening Lounge Service'">{{activityitem.sortDate | date:'shortTime'}}</span>      

                            <span  class="timecollapse" *ngIf="activityitem.type=='All Day Activity'">All Day</span>

                            <span *ngIf="activityitem.type!='Cruise'" class="activityname">{{activityitem.name}}
                                <span class="themeicon" *ngIf="activityitem.themeIcon!=null"><i class="fa-solid " [ngClass]="activityitem.themeIcon"></i></span>
                            </span>

                            <span *ngIf="activityitem.type=='Cruise'" class="activityname">{{activityitem.direction}}&nbsp;{{activityitem.name}}</span>

                        </span>
                    </a>
                    <a *ngIf="activityitem.expander" (click)="activityitem.expander = !activityitem.expander">
                        <i class="fa-solid fa-circle-minus fa-lg"></i>
                        <span class="timeslot">
                            <span class="timeexpand" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">{{activityitem.begDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='Cruise' || activityitem.type=='Evening Lounge Service'">{{activityitem.sortDate | date:'shortTime'}}</span>

                            <span class="timecollapse" *ngIf="activityitem.type=='All Day Activity'">All Day</span>

                            <span class="timecollapse" *ngIf="activityitem.endDate!=undefined && activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='All Day Activity' && activityitem.type!='HT' && activityitem.type!='OT' && activityitem.type!='Evening Lounge Service'">&nbsp;-&nbsp;{{activityitem.endDate | date:'shortTime'}}</span>

                            <span *ngIf="activityitem.type!='Cruise'" class="activityname activitynameexpand">{{activityitem.name}}
                                <span class="themeicon" *ngIf="activityitem.themeIcon!=null"><i class="fa-solid " [ngClass]="activityitem.themeIcon"></i></span>
                            </span>

                            <span *ngIf="activityitem.type=='Cruise'" class="activityname activitynameexpand">{{activityitem.direction}}&nbsp;{{activityitem.name}}</span>
                        </span>
                    </a>
                </div>

                <div class="row innerexpand" *ngIf="activityitem.expander == true">
                    <div class="col-12">
                        <div class="dailyhighlight" *ngIf="activityitem.isHighlighted"><i class="fa-solid fa-star fa-sm"></i><span>&nbsp;Daily Highlight</span></div>
                    </div>

                    <div class="guestinfo" *ngIf="activityitem.guestName!='' && activityitem.guestName!=undefined && activityitem.type=='EX'">
                        <span class="guestname">{{activityitem.guestName}}</span>
                    </div>

                    <div class="col-12" *ngIf="activityitem.type!='OT'">
                        <div class="activitydesc">{{activityitem.description}}</div>
                    </div>

                    <div class="activitylocationinfo" *ngIf="activityitem.location!='' && activityitem.location!=undefined && activityitem.deck!='Side'">
                        <span class="activitylocation" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='HT' && activityitem.type!='OT'">
                            <a [routerLink]="['/shiplocation', activityitem.deck]">{{activityitem.location}}</a>
                        </span>

                        <span *ngIf="activityitem.type=='HT'" class="activitylocation">
                            <a href='http://maps.google.com/?q={{activityitem.description}}' target="_blank">{{activityitem.location}}</a>
                        </span>

                        <span class="activityDeck" *ngIf="activityitem.deck!='' && activityitem.deck!=undefined">&nbsp;|&nbsp;{{activityitem.deck}}</span>
                    </div>

                    <div class="activitylocationinfo" *ngIf="activityitem.location!='' && activityitem.location!=undefined  && activityitem.deck=='Side'">
                        <span class="activitylocation" *ngIf="activityitem.type!='Cruise' && activityitem.type!='Survey' && activityitem.type!='HT' && activityitem.type!='OT'">{{activityitem.location}}</span>

                        <span class="activitylocation" *ngIf="activityitem.type=='Survey' && pagemask==false">
                            <a href="https://questionpro.com/t/ATOnPZ4Wrm?BookingCode={{rebcode}}&CruiseCode={{evtcode}}">Click here to complete the survey</a>
                        </span>
                    </div>

                </div>

            </div>
        </div>
    </div>

</div>